import axios from 'axios';
import { Applicant } from "../types";

const createApplicantUrl = `${process.env.REACT_APP_ONFIDO_SDK_ENDPOINT}/create-applicant-workflow`;

export const createApplicant = async (
    firstName?: string ,
    lastName?: string,
    processId?: string
) => {
    return await axios.post(createApplicantUrl, {
        applicantDetails: {
            first_name: firstName,
            last_name: lastName
        },
        processId: processId,
    }).then(result => {
        if (result.status === 200) {
            const applicant: Applicant = {
                applicantId: result.data.applicant_id,
                sdkToken: result.data.sdk_token,
                workflowRunId: result.data.workflow_run_id,
                processId: processId,
                attemptCount: 1
            };
            return applicant;
        } else {
            console.error('create applicant error');
            return {};
        }
    }).catch(error => {
        console.error(error);
        return {};
    });
};

